import "./App.css";
import React from "react";

const multipleOperators = /[\*\+/\-][\-][\+\*/]/g;
const Operators = /[\*\+\-/]/g;

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      calculations: "",
      currentValue: "0",
      prevValue: "0",
      evaluated: false,
    };
    this.clear = this.clear.bind(this);
    this.calculate = this.calculate.bind(this);
    this.handleDecimals = this.handleDecimals.bind(this);
    this.handleNumbers = this.handleNumbers.bind(this);
    this.handleOperators = this.handleOperators.bind(this);
  }

  calculate() {
    let calculations = this.state.calculations;

    if (calculations.match(multipleOperators) != null) {
      let operator = calculations.match(multipleOperators);
      calculations = calculations.replace(
        operator,
        operator[0].charAt(operator[0].length - 1)
      );

      let answer = eval(calculations);
      answer = answer.toString().replace(/0{3,}/, 0);
      this.setState({
        currentValue: answer.toString(),
        calculations: calculations + "=" + answer,
        prevValue: answer.toString(),
        evaluated: true,
      });
    } else if (calculations.match(/[\*\+/]-/g) != null) {
      let answer = eval(calculations);
      answer = answer.toString().replace(/0{3,}./, 0);
      this.setState({
        currentValue: answer.toString(),
        calculations: calculations + "=" + answer,
        prevValue: answer.toString(),
        evaluated: true,
      });
    } else {
      let answer = eval(calculations);
      answer = answer.toString().replace(/0{3,}./, 0);
      this.setState({
        currentValue: answer.toString(),
        calculations: calculations + "=" + answer,
        prevValue: answer.toString(),
        evaluated: true,
      });
    }
  }

  clear() {
    this.setState({
      currentValue: "0",
      prevValue: "0",
      calculations: "",
      evaluated: false,
    });
  }

  handleNumbers(event) {
    const value = event.target.value;
    const { calculations, currentValue, prevValue, evaluated } = this.state;
    if (this.state.currentValue == 0) {
      this.setState({
        currentValue: value,
        calculations: value,
      });
    } else if (evaluated === true) {
      if (currentValue.match(Operators) !== null) {
        this.setState({
          currentValue: currentValue + value,
          calculations: prevValue + (currentValue + value),
          evaluated: false,
        });
      } else {
        this.setState({
          currentValue: value,
          calculations: value,
          evaluated: false,
        });
      }
    } else {
      this.setState({
        currentValue: currentValue + value,
        calculations: calculations + value,
      });
    }
  }

  handleOperators(event) {
    const value = event.target.value;
    const { currentValue, calculations, prevValue, evaluated } = this.state;
    if (evaluated === true) {
      this.setState({
        calculations: prevValue + currentValue,
      });
    }
    this.setState({
      calculations: calculations + value,
      currentValue: value,
    });
  }

  handleDecimals(event) {
    const value = event.target.value;
    const { calculations, currentValue, prevValue, evaluated } = this.state;
    if (currentValue.includes(value) === true) {
      this.setState({
        currentValue: currentValue,
      });
    } else {
      this.setState({
        currentValue: currentValue + value,
        calculations: calculations + value,
      });
    }
  }

  render() {
    return (
      <div className="calculator">
        <Calculations calculations={this.state.calculations} />
        <Display currentValue={this.state.currentValue} />
        <Buttons
          clear={this.clear}
          numbers={this.handleNumbers}
          calculate={this.calculate}
          operators={this.handleOperators}
          decimals={this.handleDecimals}
        />
      </div>
    );
  }
}

class Buttons extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="buttons">
        <button
          className="big-button clear"
          id="clear"
          onClick={this.props.clear}
          value="AC"
        >
          AC
        </button>
        <button
          id="divide"
          onClick={this.props.operators}
          className="operators"
          value="/"
        >
          /
        </button>
        <button
          id="multiply"
          onClick={this.props.operators}
          className="operators"
          value="*"
        >
          x
        </button>
        <button id="seven" onClick={this.props.numbers} value="7">
          7
        </button>
        <button id="eight" onClick={this.props.numbers} value="8">
          8
        </button>
        <button id="nine" onClick={this.props.numbers} value="9">
          9
        </button>
        <button
          id="subtract"
          onClick={this.props.operators}
          className="operators"
          value="-"
        >
          ‑
        </button>
        <button id="four" onClick={this.props.numbers} value="4">
          4
        </button>
        <button id="five" onClick={this.props.numbers} value="5">
          5
        </button>
        <button id="six" onClick={this.props.numbers} value="6">
          6
        </button>
        <button
          id="add"
          onClick={this.props.operators}
          className="operators"
          value="+"
        >
          +
        </button>
        <button id="one" onClick={this.props.numbers} value="1">
          1
        </button>
        <button id="two" onClick={this.props.numbers} value="2">
          2
        </button>
        <button id="three" onClick={this.props.numbers} value="3">
          3
        </button>
        <button
          className="big-button"
          id="zero"
          onClick={this.props.numbers}
          value="0"
        >
          0
        </button>
        <button id="decimal" onClick={this.props.decimals} value=".">
          .
        </button>
        <button id="equals" onClick={this.props.calculate} value="=">
          =
        </button>
      </div>
    );
  }
}

class Display extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="display-screen" id="display">
        {this.props.currentValue}
      </div>
    );
  }
}

class Calculations extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <div className="result">{this.props.calculations}</div>;
  }
}
export default App;
